import React from 'react';
import {
  Create,
  DateInput,
  email,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { plans } from '../promocode/plans';
import { reasons } from './reasons';
import { dateFormatter, dateParser } from '../helpers/timestampDateInput';
import { ExtraFields } from './extraFields';

const SubscriptionCreate: React.FC<any> = (props) => {
  return (
    <Create {...props}>
      <SimpleForm redirect="list">
        <TextInput
          source="email"
          type="email"
          label="Email пользователя"
          validate={[email(), required()]}
        />

        <SelectInput source="planName" label="Тариф" choices={plans} />

        <DateInput
          source="nextPaymentAt"
          label="Дата следующего платежа"
          validate={required()}
          format={dateFormatter}
          parse={dateParser}
        />

        <TextInput
          multiline
          source="comment"
          type="comment"
          label="Комментарий"
        />

        <SelectInput
          source="reason"
          label="Причина"
          choices={reasons}
          validate={required()}
        />
        <ExtraFields />
      </SimpleForm>
    </Create>
  );
};

export default SubscriptionCreate;
